/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from 'react'

class Introduction extends Component {
    render() {
        return (
            <div>
                <section id="colorlib-hero" className="js-fullheight" data-section="home">
                    <div className="flexslider js-fullheight">
                        <ul className="slides">
                            <li style={{ backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/portfolio-aceb7.appspot.com/o/public%2Fimages%2Fpic.JPG?alt=media&token=39aff6b9-9d42-4e67-a49f-9d69b89e8924)' }}>
                                <div className="overlay" />
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-md-6 col-md-offset-3 col-md-pull-3 col-sm-12 col-xs-12 js-fullheight slider-text">
                                            <div className="slider-text-inner js-fullheight">
                                                <div className="desc">
                                                    <h1>Hi! <br />I'm Joshua</h1>
                                                    <p><a className="btn btn-primary btn-learn" href="https://docs.google.com/document/d/17lR1O_VKwLOHK-0QHlfvzWkRvDd6jZOiLxPm9PmZmGs/edit#heading=h.5rf9wr4r3no2" target="_blank">View CV<i className="icon-download4" /></a></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li style={{ backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/portfolio-aceb7.appspot.com/o/public%2Fimages%2Fpic.JPG?alt=media&token=39aff6b9-9d42-4e67-a49f-9d69b89e8924)' }}>
                                <div className="overlay" />
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-md-6 col-md-offset-3 col-md-pull-3 col-sm-12 col-xs-12 js-fullheight slider-text">
                                            <div className="slider-text-inner">
                                                <div className="desc">
                                                    <h1>I love building<br /> THINGS !!</h1>
                                                    {/*<p><a className="btn btn-primary btn-learn" href="https://github.com/Dhruv34788" target="_blank">View Projects <i className="icon-briefcase3" /></a></p>*/}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li style={{ backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/portfolio-aceb7.appspot.com/o/public%2Fimages%2Fpic.JPG?alt=media&token=39aff6b9-9d42-4e67-a49f-9d69b89e8924)' }}>
                                <div className="overlay" />
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-md-6 col-md-offset-3 col-md-pull-3 col-sm-12 col-xs-12 js-fullheight slider-text">
                                            <div className="slider-text-inner">
                                                <div className="desc">
                                                    <h1>I often <br />Write ... </h1>
                                                    {/* <p><a className="btn btn-primary btn-learn" href="https://medium.com/@dhruv.barochia34788" target="_blank">View Blog <i className="icon-book" /></a></p>*/}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </section>
            </div>
        )
    }
}
export default Introduction; 